import { API } from "../constant/apiConstant";
import {
  ADMIN_SESSION_EXPIRED_MESSAGE,
  broadcastAdminLogout,
  getAdminSessionExpiryMessage,
  shouldHandleAdminSessionExpiry
} from "../utils/adminSessionTimeout";

const isAuthFailure = (data, statusCode) =>
  shouldHandleAdminSessionExpiry(data, statusCode);

export const adminFetch = async (url, options = {}) => {
  const isFormData = options?.body instanceof FormData;
  const headers = isFormData
    ? { ...(options.headers || {}) }
    : {
        "Content-Type": "application/json",
        ...(options.headers || {})
      };
 
  const request = async () =>
    fetch(`${API.BASE_URL}${url}`, {
      credentials: "include",
      headers,
      ...options
    });

  try {
    let res = await request();
    let data = await res.json();

    if (isAuthFailure(data, res.status)) {
      const refreshRes = await fetch(`${API.BASE_URL}/api/admin/auth/refresh`, {
        method: "POST",
        credentials: "include"
      });

      const refreshData = await refreshRes.json().catch(() => null);

      if (refreshData?.status) {
        res = await request();
        data = await res.json();
      }
    }

    if (isAuthFailure(data, res.status)) {
      await fetch(`${API.BASE_URL}/api/admin/auth/logout`, {
        method: "POST",
        credentials: "include"
      });

      broadcastAdminLogout({
        reason: "server",
        message: getAdminSessionExpiryMessage(data) || ADMIN_SESSION_EXPIRED_MESSAGE
      });
      window.location.href = "/";
      return null;
    }

    return data;

  } catch (error) {
    console.log("API Error:", error);
    return null;
  }
};
